import React from "react";
import contactme from "../Assets/contactme.gif";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import {
  FaGithub,
  FaTwitter,
  FaLinkedin,
  FaInstagram,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";
import { FaArrowDown } from "react-icons/fa";
import { Link } from "react-router-dom";
const ContactMe = () => {
  return (
    <div className="contact-section">
      <div className="contact-col">
        <div>
          <h1>Contact Me</h1>
        </div>

        <div className="skills-icons-div HomelogoHbox">
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="GitHubTooltip">
                <strong>GitHub</strong>
              </Tooltip>
            }
          >
            <a
              href="https://github.com/sumanthn3"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGithub
                className="iconSize borderIconHome"
                style={{ color: "white", fontSize: "24px" }}
              />
            </a>
          </OverlayTrigger>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="TwitterTooltip">
                <strong>Twitter</strong>
              </Tooltip>
            }
          >
            <a
              href="https://www.linkedin.com/in/sumanthnandeti/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter
                className="iconSize borderIconHome"
                style={{ color: "#1DA1F2", fontSize: "24px" }}
              />
            </a>
          </OverlayTrigger>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="LinkedinTooltip">
                {" "}
                <strong>LinkedIn</strong>
              </Tooltip>
            }
          >
            <a
              href="https://www.linkedin.com/in/sumanthnandeti/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin
                className="iconSize borderIconHome"
                style={{ color: "#1DA1F2", fontSize: "24px" }}
              />
            </a>
          </OverlayTrigger>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="instaTooltip">
                <strong>Instagram</strong>
              </Tooltip>
            }
          >
            <a
              href="https://www.instagram.com/sumanthnandeti"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram
                className="iconSize borderIconHome"
                style={{ color: "#E4405F", fontSize: "24px" }}
              />
            </a>
          </OverlayTrigger>
        </div>
        <div className="contact-details">
          <span className="contact-icon">
            <FaEnvelope />
          </span>
          <span className="contact-text">sumanthnandeti3@gmail.com</span>
        </div>
        <div className="contact-details">
          <span className="contact-icon">
            <FaPhoneAlt />
          </span>
          <span className="contact-text">+1 (571)-457-2041</span>
        </div>
      </div>
      <img className="ImageContact" src={contactme} alt="" width="450" />
    </div>
  );
};

export default ContactMe;
